module.exports = __webpack_public_path__ + "static/media/register.21803ea2.svg";